<template>
  <div>
      <el-button  @click="connectToSerialPort">连接串口</el-button>
      <el-input
        v-model="inputData"
        maxlength="50"
        placeholder="输入发送数据内容"
        show-word-limit
        type="textarea"
      />
      <el-button  @click="sendData">发送数据</el-button>
      <el-button  @click="cutPort">断开串口</el-button>
  </div>
</template>

<script>
export default {
  data(){
    return{
      port:'',
      ports:[],
      reader:'',
      inputData:''
    }
  },
  mounted(){
    if ("serial" in navigator) {
      console.log(true);
    } else {
      console.log(false);
    }
  },
  methods:{
    async connectToSerialPort(){
      try {
        // 提示用户选择一个串口
        this.port = await navigator.serial.requestPort();
        console.log(this.port);
        // 获取用户之前授予该网站访问权限的所有串口。
        this.ports = await navigator.serial.getPorts();

        // console.log(port.value, ports.value);
        // 等待串口打开
        await this.port.open({ baudRate: 9600 });

        // console.log(typeof port.value);
        // ElMessage({
        //   message: "",
        //   type: "success",
        // });
        alert('成功连接串口')
        // readData(port.value);
        this.readData();
      } catch (error) {
        // 处理连接串口出错的情况
        console.log("Error connecting to serial port:", error);
      }
    },
    async sendData(){
            // if (port.value && port.value.isOpen) {
      if (this.port) {
        if (this.inputData) {
          const writer = this.port.writable.getWriter();
          console.log("发送数据");
          await writer.write(new TextEncoder().encode(this.inputData));
          await writer.close();
        } else {
          // return ElMessage({
          //   message: "",
          //   type: "warning",
          //   showClose: true,
          //   grouping: true,
          //   duration: 2000,
          // });
          alert('输入需要发送的数据内容')
        }
      } else {
      
        alert('串口未连接或未打开！')
        // console.error("串口未连接或未打开！");
      }
    },
    async cutPort(){
      if (this.port !== "") {
        await this.reader.cancel();
        await this.port.close();
        this.port = "";
        console.log("断开串口连接");
        alert('已成功断开串口连接')
        
      } else {
        alert('请先连接或打开串口')
        // ElMessage({
        //   message: "",
        //   type: "warning",
        //   showClose: true,
        //   grouping: true,
        //   duration: 2000,
        // });
        // console.error("串口未连接或未打开！");
      }
    },
    async readData(){
      this.reader = this.port.readable.getReader();
      // 监听来自串口的数据
      while (true) {
        const { value, done } = await this.reader.read();
        if (done) {
          // 允许稍后关闭串口
          this.reader.releaseLock();
          break;
        }
        // 获取发送的数据
        const serialData = new TextDecoder().decode(value);
        console.log(serialData);
        // value 是一个 Uint8Array
        if(value.length==8){
          let num = (value[4].toString(16)+value[5].toString(16)+value[6].toString(16)+'00')
          let vls =  parseInt(num,16)
          console.log(vls)
        }
      }
    }
  }
}
</script>
<!-- <script setup>
import { ref, onMounted } from "vue";
const port = ref("");
const ports = ref([]);
const reader = ref("");

const connectToSerialPort = async () => {
  try {
    // 提示用户选择一个串口
    port.value = await navigator.serial.requestPort();

    // 获取用户之前授予该网站访问权限的所有串口。
    ports.value = await navigator.serial.getPorts();

    // console.log(port.value, ports.value);
    console.log(port.value);
    // 等待串口打开
    await port.value.open({ baudRate: 9600 });

    // console.log(typeof port.value);
    // ElMessage({
    //   message: "",
    //   type: "success",
    // });
    alert('成功连接串口')
    // readData(port.value);
    readData();
  } catch (error) {
    // 处理连接串口出错的情况
    console.log("Error connecting to serial port:", error);
  }
};

const readData = async () => {
  reader.value = port.value.readable.getReader();
  console.log(reader);
  // 监听来自串口的数据
  while (true) {
    const { value, done } = await reader.value.read();
    if (done) {
      // 允许稍后关闭串口
      reader.value.releaseLock();
      break;
    }
    // 获取发送的数据
    const serialData = new TextDecoder().decode(value);
    console.log(serialData);
    // value 是一个 Uint8Array
    if(value.length==8){
      let num = (value[4].toString(16)+value[5].toString(16)+value[6].toString(16)+'00')
      let vls =  parseInt(num,16)
      console.log(vls)
    }
  }
};

const inputData = ref("");
//
const sendData = async () => {
  // if (port.value && port.value.isOpen) {
  if (port.value) {
    if (inputData.value) {
      const writer = port.value.writable.getWriter();
      console.log("发送数据");
      await writer.write(new TextEncoder().encode(inputData.value));
      await writer.close();
    } else {
      // return ElMessage({
      //   message: "",
      //   type: "warning",
      //   showClose: true,
      //   grouping: true,
      //   duration: 2000,
      // });
      alert('输入需要发送的数据内容')
    }
  } else {
  
    alert('串口未连接或未打开！')
    // console.error("串口未连接或未打开！");
  }
};

// 断开接口
const cutPort = async () => {
  if (port.value !== "") {
    await reader.value.cancel();
    await port.value.close();
    port.value = "";
    console.log("断开串口连接");
    alert('已成功断开串口连接')
    
  } else {
    alert('请先连接或打开串口')
    // ElMessage({
    //   message: "",
    //   type: "warning",
    //   showClose: true,
    //   grouping: true,
    //   duration: 2000,
    // });
    // console.error("串口未连接或未打开！");
  }
};

onMounted(() => {
  // 判断浏览器支持串口通信
  if ("serial" in navigator) {
    console.log(true);
  } else {
    console.log(false);
  }
  // 页面刷新提示
  // window.onbeforeunload = e => {
  //   console.log(e);
  //   // 兼容IE8和Firefox 4之前的版本
  //   if (e) {
  //     e.returnValue = '关闭提示'
  //   }
  //   // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
  //   return '关闭提示'
  // }
});
</script> -->